
import { IOrcamento } from "app/types/IOrcamento"
import globalMU from "globalMU"
import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { atualizarItensAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import { tratamentoErroPadrao } from "../tratamentoErroPadrao"


export type AtualizarOrcamentoResumoParams = {
    orcamento: IOrcamento
}

declare var window: any


export async function atualizarOrcamentoResumo(params: AtualizarOrcamentoResumoParams) {
    try {
        globalMU.blockUI({ tryPassiveLoading: true })
        const resultado = await microuniversoApi.Orcamento.atualizarDadosOrcamento(params.orcamento);

        const orcamentoAlterado: IOrcamento = {
            ...params.orcamento,
            Situacao: resultado.Situacao,
            FinalidadeVenda: resultado.FinalidadeVenda,
            DataValidade: resultado.DataValidade,
            PedidoCompraCliente: resultado.PedidoCompraCliente,
            TipoOperacao: resultado.TipoOperacao,
            ObservacaoNF: resultado.ObservacaoNF,
            ObservacaoOrcamento: resultado.ObservacaoOrcamento,
            UsarObservacaoTextoLivreNF: resultado.UsarObservacaoTextoLivreNF,
            CalcularFreteAutomaticamente: false,

            DescontoAcumulado: resultado.DescontoAcumulado,
            ItensOrcamento: resultado.ItensOrcamento,
            PercentualDesconto: resultado.PercentualDesconto,
            PercentualDescontoAcumulado: resultado.PercentualDescontoAcumulado,
            PercentualDescontoAcumuladoSobreMercadoriasImportadas: resultado.PercentualDescontoAcumuladoSobreMercadoriasImportadas,
            PercentualDescontoAcumuladoSobreMercadoriasNacionais: resultado.PercentualDescontoAcumuladoSobreMercadoriasNacionais,
            PercentualDescontoSobreMercadoriasImportadas: resultado.PercentualDescontoSobreMercadoriasImportadas,
            PercentualDescontoSobreMercadoriasNacionais: resultado.PercentualDescontoSobreMercadoriasNacionais,
            PercentualSeguroEntrega: resultado.PercentualSeguroEntrega,
            SubTotal: resultado.SubTotal,
            TipoTratamentoDesconto: resultado.TipoTratamentoDesconto,
            ValorAcrescimoFinanceiro: resultado.ValorAcrescimoFinanceiro,
            ValorDesconto: resultado.ValorDesconto,
            ValorDescontoAcumuladoSobreMercadoriasImportadas: resultado.ValorDescontoAcumuladoSobreMercadoriasImportadas,
            ValorDescontoAcumuladoSobreMercadoriasNacionais: resultado.ValorDescontoAcumuladoSobreMercadoriasNacionais,
            ValorDescontoIcms: resultado.ValorDescontoIcms,
            ValorDescontoIcmsDesonerado: resultado.ValorDescontoIcmsDesonerado, // 428915/313149
            ValorDescontoSobreMercadoriasImportadas: resultado.ValorDescontoSobreMercadoriasImportadas,
            ValorDescontoSobreMercadoriasNacionais: resultado.ValorDescontoSobreMercadoriasNacionais,
            ValorDespesasInclusas: resultado.ValorDespesasInclusas,
            ValorFrete: resultado.ValorFrete,
            ValorIPI: resultado.ValorIPI,
            ValorSeguroEntrega: resultado.ValorSeguroEntrega,
            ValorSubstituicao: resultado.ValorSubstituicao,
            ValorTotal: resultado.ValorTotal,
            ValorTotalMercadorias: resultado.ValorTotalMercadorias,
            ValorTotalMercadoriasImportadas: resultado.ValorTotalMercadoriasImportadas,
            ValorTotalMercadoriasNacionais: resultado.ValorTotalMercadoriasNacionais,
            ValorTotalPendente: resultado.ValorTotalPendente,
            ValorTotalSolicitado: resultado.ValorTotalSolicitado,
            ValorServicoAdicionalDespesa: resultado.ValorServicoAdicionalDespesa,

            LimiteCreditoCliente: resultado.LimiteCreditoCliente, // 448734
            LimiteCreditoClienteBloqueado: resultado.LimiteCreditoClienteBloqueado, // 448734
            LimiteCreditoClientePendenciaFinanceira: resultado.LimiteCreditoClientePendenciaFinanceira, // 448734
    
            SaldoCashbackCliente: resultado.SaldoCashbackCliente, // 438892
            ValidadeCashbackCliente: resultado.ValidadeCashbackCliente,
            ValorCashbackUtilizado: resultado.ValorCashbackUtilizado,
            AplicaDescontoCashback: resultado.AplicaDescontoCashback,
        }
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamentoAlterado)
        store.dispatch(sobrescreverInformacoesAction(orcamentoAlterado))

        // const atualizarOrcamentoLegado = () => {
        //     const orcamentoLegado = window.orcamentoController.model

        //     orcamentoLegado.atualizar(orcamentoAlterado, true, true)

        //     store.dispatch(sobrescreverInformacoesAction(orcamentoAlterado))
        // }


        if (resultado && !("Error" in resultado)) {
            const itens = resultado.ItensOrcamento
            const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]
            store.dispatch(atualizarItensAction({itens, acao: "SOBRESCREVER",corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
        }

        if (!("HasErrors" in resultado)) {
            globalMU.showSuccessMessage("Dados do orçamento atualizados com sucesso.");
        }

        if (resultado.ValorTotalMercadorias && params.orcamento.ValorTotalMercadorias !== resultado.ValorTotalMercadorias) {
            if (!resultado.AplicaDescontoCashback && params.orcamento.AplicaDescontoCashback != resultado.AplicaDescontoCashback && resultado.Situacao == 6) // Situacao == 6 ->SoOrcando
            { // 438892
                global.showInfoMessage("Cashback foi removido</br></br>Valor total das mercadorias foi alterado!");
            }
            else if (!resultado.AplicaDescontoCashback && params.orcamento.AplicaDescontoCashback != resultado.AplicaDescontoCashback) { // 438892
                global.showInfoMessage("Saldo do cashback do cliente está zerado.</br>Cashback foi removido</br>Favor analisar os descontos!</br></br>Valor total das mercadorias foi alterado!");
            }
            else {
                globalMU.showInfoMessage("Valor total das mercadorias foi alterado! ");
            }
        }

        if (resultado && !("HasErrors" in resultado) && resultado.VendaComAutorizado) {
            globalMU.showInfoMessage("Cliente autorizado não informado.<br>Informe a senha do autorizado para continuar!");
            setTimeout(function () {
                $('#detalhe-resumo-orcamento-region').hide();
                window.orcamentoController.renderizarViewAutorizadoOrcamentoReact();
            }, 3000);
        }
    } catch (e) {
        tratamentoErroPadrao(e);
    } finally {
        globalMU.unblockUI()
    }
}